import { Helmet } from "react-helmet-async";
import { SITE_URL, DEFAULT_DESCRIPTION, OG_IMAGE_PATH } from "../../../constants/seo";

const SITE_NAME = "South Asia Consultancy";
const DEFAULT_OG_IMAGE = `${SITE_URL}${OG_IMAGE_PATH}`;

function Seo({
  title,
  description = DEFAULT_DESCRIPTION,
  path = "/",
  ogImage = DEFAULT_OG_IMAGE,
  noIndex = false,
}) {
  const pageTitle = title
    ? `${title} | ${SITE_NAME}`
    : `${SITE_NAME} | Integrated Oilfield Services`;
  const canonicalPath = path.startsWith("/") ? path : `/${path}`;
  const imageUrl = ogImage.startsWith("http") ? ogImage : `${SITE_URL}${ogImage}`;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={`${SITE_URL}${canonicalPath}`} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={`${SITE_URL}${canonicalPath}`} />
      <meta property="og:image" content={imageUrl} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={description} />
      {noIndex && <meta name="robots" content="noindex,nofollow" />}
    </Helmet>
  );
}

export default Seo;
